import { Navigate, Route, Routes } from 'react-router-dom';
import AppRoute from './routes/AppRoute';
import AuthRoute from './routes/AuthRoute';
import PaymentRoute from './routes/PaymentRoute';
import { AISurveyRoute } from './routes/AISurveyRoute';
import PromotionRoute from './routes/PromotionRoute';
import CategoryRoot from './routes/CategoryRoute';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import RouteGuard from './routes/RouteGuard';
import DeepLinkRoot from './pages/DeepLink/Root';
import LandingRoot from './pages/Landing/Root';
import SleepingJellyCouponPage from './pages/Sleeping/SleepingJellyCoupon';
import EunpyeongCareCompletePage from './pages/Eunpyeongcare/EunpyeongCareCompletePage';
import EunpyeongCareCouponPage from './pages/Eunpyeongcare/EunpyeongCareCouponPage';
import EunpyeongCareDashboardPage from './pages/Eunpyeongcare/EunpyeongCareDashboardPage';
import SessionResultPage from './pages/SessionResult/SessionResultPage';
import OpenSoundPillPage from './pages/OpenSoundPill/OpenSoundPillPage';
import FaceWellnessPage from './pages/FaceWellness/FaceWellnessPage';
import PrivatePolicyEnPage from './pages/Consent/PrivatePolicyEnPage';
import { ToastContainer } from 'react-toastify';
import useRouteLoggerHook from './hooks/useRouteLogger';

function App() {
  const { t } = useTranslation();
  useRouteLoggerHook()
  return (
    <>
      <Helmet>
        <html lang="ko" />
        <title>{t('title')}</title>
        <meta name="description" content={t('description')} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="사운드필" />
        <meta property="og:title" content={t('title')} />
        <meta property="og:description" content={t('description')} />
        <meta property="og:url" content="https://soundpill.app/" />
        <meta property="og:image" content="https://soundpill.app/logo512.png" />
        <meta property="og:locale" content="ko_KR" />
      </Helmet>
      <ToastContainer/>
      <RouteGuard/>
      <Routes>
        <Route path="/app/*" element={<AppRoute />} />
        <Route path="/category/*" element={<CategoryRoot />} />
        <Route path={'/auth/*'} element={<AuthRoute />} />
        <Route path={'/payment/*'} element={<PaymentRoute />} />
        <Route path="ai-survey/*" element={<AISurveyRoute />} />
        <Route path="promotion/*" element={<PromotionRoute />} />
        <Route path="deep-link/*" element={<DeepLinkRoot/>} />
        <Route path='landing/*' element={<LandingRoot/>}/>
        <Route path='jelly/coupon' element={<SleepingJellyCouponPage/>}/>
        <Route path='eunpyeongcare/coupon' element={<EunpyeongCareCouponPage/>}/>
        <Route path='eunpyeongcare/complete' element={<EunpyeongCareCompletePage/>}/>
        <Route path='eunpyeongcare/dashboard' element={<EunpyeongCareDashboardPage/>}/>
        {/* 태블릿 QR 세션 결과 — 로그인 불필요 */}
        <Route path="qr-session-result" element={<SessionResultPage />} />
        <Route path="open-soundpill" element={<OpenSoundPillPage />} />
        {/* 얼굴 웰니스 체험 — 로그인 불필요 */}
        <Route path="face-wellness" element={<FaceWellnessPage />} />
        {/* 영문 개인정보처리방침 — 앱 셸 밖 공개 페이지 (스토어/헬스킷 URL용) */}
        <Route path="privacy-policy-en" element={<PrivatePolicyEnPage />} />
        <Route path={'*'} element={<Navigate to="/app/*" />} />
      </Routes>
    </>
  );
}

export default App;
